import { Chain } from './chain';
import { Asset } from './asset';

export class LiquidityBotRequest {
  public chain: Chain;
  public sellAsset: Asset;
  public buyAsset: Asset;

  public usdAmount: number;
}
